










































import Vue from "vue";
export default Vue.extend({
  props: [
    "color",
    "icon",
    "isLoading",
    "count",
    "selected",
    "trigger",
    "tooltip",
  ],
});
